export const randomIntFromInterval = (min: number, max: number) => {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const randomFloatFromInterval = (min: number, max: number) => {
  // min and max included
  return +(Math.random() * (max - min + 1) + min).toFixed(2);
};
